import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { ReportRequestData, TransactionReportResponse } from "../../../../graphql/types"

export const fetchTransactionsReportData = (
    headers: Record<string, any>,
    data: ReportRequestData
): Promise<Maybe<TransactionReportResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query transactionsReport($data: ReportRequestData!) {
                  transactionsReport(data: $data) {
                    data {
                        id
                        transactionNumber
                        orderNumber
                        currency
                        paymentType
                        transactorName
                        assigneeId
                        assigneeName
                        operation
                        entryMode
                        total
                        result
                        resultMessage
                        initiatedOffline
                        approvalCode
                        terminalId
                        terminalName
                        locationId
                        locationName
                        paymentSubtype
                        externalPaymentType
                        timestamp                  
                    }
                    totalCount
                  }
                }
                
            `,
            operationName: "transactionsReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.transactionsReport) {
            return response.data.transactionsReport
        }

        return null
    })
